export const TextAlign = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
  CENTER: 'CENTER',
};

// TOP means the text grows upwards and BOTTOM downwards.
export const VerticalAlign = {
  TOP: 'TOP',
  BOTTOM: 'BOTTOM',
  CENTER: 'CENTER',
};

export default { TextAlign, VerticalAlign };
